export interface IWebpageLinkResources {
  text: string;
}

export const WebpageLinkResources: IWebpageLinkResources = {
  text: "Strona www",
};
